import { createAction } from '@reduxjs/toolkit';

export const externalServiceLaunched = createAction(
  'externalServiceLaunched',
  (payload: { serviceId: string; reportUrl: string | null; elementId: string; elementName: string }) => ({ payload })
);
